import { render } from "./BrokerAccounts.vue?vue&type=template&id=60e02eb4&scoped=true"
import script from "./BrokerAccounts.vue?vue&type=script&lang=js"
export * from "./BrokerAccounts.vue?vue&type=script&lang=js"

import "./BrokerAccounts.vue?vue&type=style&index=0&id=60e02eb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e02eb4"]])

export default __exports__